<div class="tabs-container" [ngClass]="font?.size">
  <div class="tab-item" *ngFor="let tab of tabs">
    <span class="tab" [class.active]="activeTab.route === tab.route" (click)="selectTab(tab)">
      {{ tab.name | translate }}
    </span>
  </div>
</div>